export type StatusType = 'processing' | 'done' | 'failed';

interface StatusChipProps {
  status: StatusType;
}

export function StatusChip({ status }: StatusChipProps) {
  const statusConfig = {
    done: {
      className: 'bg-success-bg text-success',
      label: 'Done',
    },
    failed: {
      className: 'bg-destructive-bg text-destructive',
      label: 'Failed',
    },
    processing: {
      className: 'bg-warning-bg text-warning',
      label: 'Processing',
    },
  };

  const config = statusConfig[status];

  return (
    <span
      className={`rounded-sm px-2 py-0.5 font-['Inter'] text-[10px] font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
}
